
<template>
    <div>
        <el-table :data="noticeList" style="width: 100%" @row-click="onInfo">
            <el-table-column :show-overflow-tooltip="true" label="资讯标题" prop="title">
                <template slot-scope="scope">
                    <a href="javascript:;" class='sucess'>{{ scope.row.title }}</a>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="资讯摘要" prop="summary" v-if="!hideHeader">
                <template slot-scope="scope">
                    <a href="javascript:;" class='sucess'>{{ scope.row.summary }}</a>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="创建日期" prop="createTime" width="180">
                <template slot-scope="scope">
                    <div class="release-time">{{ scope.row.createTime }}</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import home from "@/api/home/index"
export default {

    data() {
        return {
            noticeList:[]
        };
    },

    mounted() {

    },

    methods: {
        // 通知公告（最新）
        pageNotice() {
            home.pageNotice({
                page: 1,
                limit: 2
            }).then(res => {
                if (res.code == 0) {
                    this.noticeList = res.data.list;
                }
            })
        },
    },
};
</script>

<style lang="less" scoped></style>